import openapiSchema from '@openapi';

const { paths } = openapiSchema as { paths: Record<string, unknown> };
const maasPathKeys = Object.keys(paths).filter((p: string) => p.startsWith('/api/v2/compute/maas'));

const pathMigrations = maasPathKeys.find((p: string) => p === '/api/v2/compute/maas/migrations');
const pathMigrationsDeployments = maasPathKeys.find((p: string) => p === '/api/v2/compute/maas/migrations/{migration_id}/deployments');
const pathMigrationsReplications = maasPathKeys.find((p: string) => p === '/api/v2/compute/maas/migrations/{migration_id}/replications');
const pathClouds = maasPathKeys.find((p: string) => p === '/api/v2/compute/maas/clouds');
const pathCloudInstances = maasPathKeys.find((p: string) => p === '/api/v2/compute/maas/clouds/{cloud_id}/instances/{instance_id}');

if (!pathMigrations || !pathMigrationsDeployments || !pathMigrationsReplications || !pathClouds || !pathCloudInstances) {
  throw new Error('MAAS paths missing in backend schema');
}

export const getMigrationsUrl = () => pathMigrations;
export const getDeploymentsUrl = (migrationId: string) => pathMigrationsDeployments.replace('{migration_id}', migrationId);
export const getReplicationsUrl = (migrationId: string) => pathMigrationsReplications.replace('{migration_id}', migrationId);
export const getCloudsUrl = () => pathClouds;
export const getCloudInstanceUrl = (cloudId: string, instanceId: string) => pathCloudInstances.replace('{cloud_id}', cloudId).replace('{instance_id}', instanceId);
